import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import PropTypes from "prop-types";
import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  content: {
    position: "relative",
    padding: theme.spacing(1),
    "&:last-child": {
      paddingBottom: theme.spacing(1) / 2,
    },
  },
  icon: {
    boxShadow: "none",
    color: "white",
    padding: theme.spacing(1) * 1,
  },
  iconFloat: {
    position: "absolute",
    right: "15px",
    top: "50%",
    marginTop: "-20px",
    opacity: "0.2",
    transform: "rotate(-5deg)",
  },
  lightText: {
    color: '#000' //"white",
  },
  leftText: {
    marginLeft: theme.spacing(1) / 2
  }
}));

const StatCard = ({ type, title, value, icon, color }) => {
  const classes = useStyles();
  let before = null;
  let after = null;

  const cardIcon = (
    <Grid item className={type === "fill" ? classes.iconFloat : null}>
      <IconButton
        className={classes.icon}
        aria-label={title}
        style={{ backgroundColor: color }}
        size="small"
      >
        {icon}
      </IconButton>
    </Grid>
  );

  if (icon) {
    type === "fill" ? (after = cardIcon) : (before = cardIcon);
  }

  return (
    <Card style={type === "fill" ? { borderBottomColor: color, borderBottomStyle: 'solid' } : null}>
      <CardContent className={classes.content}>
        <Grid
          container
          alignItems={"center"}
          direction={"row"}
          justifyContent={"flex-start"}
        >
          {before}
          <Grid item>
            <div className={type === "fill" ? "pr-1" : "px-1"}>
              <Typography
                variant="body2"
                className={type === "fill" ? classes.lightText : classes.leftText}
              >
                {title}
              </Typography>
              <Typography
                variant="h6"
                className={type === "fill" ? classes.lightText : classes.leftText}
              >
                {value}
              </Typography>
            </div>
          </Grid>
          {after}
        </Grid>
      </CardContent>
    </Card>
  );
};

StatCard.propTypes = {
    type: PropTypes.oneOf(["fill"]),
    title: PropTypes.string,
    value: PropTypes.any,
    icon: PropTypes.element,
    color: PropTypes.string,
};

export default StatCard;
